module.exports = __webpack_public_path__ + "static/media/ContactLeft_TH.dfa9ac1f.png";